export class UploadChamado {
  idAtividade: number;
  nome: string;

  constructor( nome: string) {
    this.idAtividade = null;
    this.nome = nome;
  }
}
